// Audit endpoints: /api/v1/admin/platform/audit and /logins (API_CONTRACT.md › Audit).

import { apiFetch } from './client'
import type { AuditListParams, AuditListResponse, ExportResponse, LoginListParams, LoginListResponse } from './types'

export function listAudit(params: AuditListParams = {}, signal?: AbortSignal): Promise<AuditListResponse> {
  const { exclude_super_admin, ...rest } = params
  return apiFetch('/admin/platform/audit', { query: { ...rest, exclude_super_admin: exclude_super_admin ? true : undefined }, signal })
}

/** `summary` covers the whole filtered range, not just this page. */
export function listLogins(params: LoginListParams = {}, signal?: AbortSignal): Promise<LoginListResponse> {
  return apiFetch('/admin/platform/logins', { query: { ...params }, signal })
}

/**
 * Full server-side CSV. The server returns a short-lived signed URL, so the
 * bearer token never goes into a query string.
 */
export function auditExport(params: AuditListParams): Promise<ExportResponse> {
  const { limit: _limit, cursor: _cursor, ...filters } = params
  return apiFetch('/admin/platform/audit/export', { method: 'POST', body: filters })
}

export function loginsExport(params: LoginListParams): Promise<ExportResponse> {
  const { limit: _limit, cursor: _cursor, ...filters } = params
  return apiFetch('/admin/platform/logins/export', { method: 'POST', body: filters })
}
